export class TraceabilityType {
  public static readonly BASIC = 1;
  public static readonly SIGNATURE_COMPONENT = 2;
  public static readonly VISUALIZACION = 3;
  public static readonly MAILING = 4;
}
